import { AlbinaProcessor } from "./albinaBlog";
import { BloggerProcessor } from "./blogger";
import { SnowProfilesProcessor } from "./snowProfiles";
import { WordpressProcessor } from "./wordpress";

export * from "./blogConfig";
export * from "./blogProcessor";
export * from "./blogPostPreviewItem";
export * from "./albinaBlog";
export * from "./blogger";
export * from "./snowProfiles";
export * from "./wordpress";

export const blogProcessors = Object.freeze({
  albina: new AlbinaProcessor(),
  blogger: new BloggerProcessor(),
  wordpress: new WordpressProcessor(),
  snowProfiles: new SnowProfilesProcessor()
});
